<template>
  <div :class="claz"></div>
</template>
<script>
export default {
  props: {
    open: Boolean,
    variant: {
      type: String,
      default: ""
    }
  },
  computed: {
    claz() {
      const openClass = this.open ? "caret-up" : "caret-down";
      const variantClass = this.variant ? openClass + "-" + this.variant : "";
      return openClass + " " + variantClass;
    }
  }
}
</script>
<style scoped>
.caret-up {
  width: 0px;
  height: 0px;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #000;
  margin-right:5px;
}

.caret-down {
  width: 0px;
  height: 0px;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #000;
  margin-right:5px;
}

.caret-down-red {
  border-top: 5px solid #EF3D49;
}

.caret-up-red {
  border-bottom: 5px solid #EF3D49;
}

</style>